import { ApiDatasourceSpec } from '../../../core/datasource';
import { HttpClient } from '../network/HttpClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '';

export class ApiDatasource implements ApiDatasourceSpec {
    constructor(public readonly remote = new HttpClient(API_BASE_URL)) {}
}
